/* 🤖 this file was generated by svg-to-ts */
export const mgcIconDownSmallRegular: {
  name: 'down-small-regular';
  data: string;
} = {
  name: 'down-small-regular',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M8.92 10.035c-.461.151-.728.505-.728.965 0 .441.027.476 1.68 2.128 1.652 1.653 1.687 1.68 2.128 1.68s.476-.027 2.128-1.68c1.653-1.652 1.68-1.687 1.68-2.128 0-.392-.192-.705-.547-.893-.212-.112-.657-.118-.861-.012-.077.04-.648.579-1.27 1.199L12 12.419l-1.13-1.125c-.622-.62-1.191-1.157-1.266-1.194-.156-.078-.535-.114-.684-.065"/></svg>`
};
